import React from "react";
import DisplayComponent from "./DisplayComponent";
import { Meet } from "types";
import { WidgetId, useDisplaySettings } from "./DisplaySettingsProvider";
import find from "lodash/find";
import first from "lodash/first";
import { COUCH_DB_SERVER } from "util/api";

const Image = ({ meet, id }: { meet: Meet; id: WidgetId }) => {
  const { state } = useDisplaySettings();

  const imageSrc = state.i.is;

  const onlineImageUrl = React.useMemo(() => {
    const attachDocument = find(meet?.attachments, (a) => {
      return !!find(Object.keys(a?._attachments ?? {}), (at) => {
        return at === imageSrc;
      });
    });

    if (!attachDocument) {
      return "";
    }

    const attachment = attachDocument?._attachments
      ? first(Object.keys(attachDocument?._attachments))
      : undefined;

    if (!attachment) {
      return "";
    }
    const url = `${COUCH_DB_SERVER}/${meet._id}_readonly/${attachDocument._id}/${attachment}`;

    return url;
  }, [imageSrc, meet._id, meet?.attachments]);
  return (
    <DisplayComponent style={{ top: 800, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 22,
          width: sizeMultiplier * 300,
          minHeight: sizeMultiplier * 100,
        };

        return (
          <div style={style} className="lifter-details">
            <img draggable={false} style={style} src={onlineImageUrl} alt="" />
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default Image;
